<template>
  <div class="about-box">
    <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <img src="../assets/img/about-banner1.jpg" class="center-block w100" alt=""/>
        </swiper-slide>
    </swiper>
    <div class="about-content-box">
      <div id="id13" class="bg1 pt-29 pb-28.8">
        <div class="container">
          <div class="title-box">
            <div class="title">公司简介</div>
            <div class="subtitle">PRODUCT INTRODUCTION</div>
          </div>
          <div class="row content-box flex-center flex-item-center xs-column-center">
            <div class="col-xs-12 col-md-4 col-lg-4 text-right">
              <img src="../assets/img/max-logo.png" alt="" class="max-logo"/>
            </div>
            <div class="col-xs-12  col-md-8 col-lg-8 content-text">
              惠宾科技成立于2009年，是国内领先的智慧医疗解决方案和互联网医院解决方案提供商，是专业的“互联网+健康医疗”服务运营商。
              <br>
              <br>
              惠宾科技的智慧医疗解决方案以为医院节能增效为目标，以流程再造为理念，提供覆盖全流程诊疗、精细化管 理、专业化运营软件及服务。目前全国已有多家三级医院选择惠宾科技的智慧医疗产品及运营服务。
              <br>
              <br>
              公司运营的惠宾健康医疗服务平台，作为专业的患者就医助手，为公众提供更便民、更高效的线上线下 一体化、一站式、全流程就医服务，全面服务于社会。
              <br>
              <br>
              惠宾科技秉承“开放、创新、合作、共赢” 的核心价值观，以“服务社会，惠及民生”为使命，致力提高健康医疗科技服务，助力机构适应健康医疗新业态。基于健康医疗服务模式及智慧医疗服务的升级，建立产业互 联网的新生态。
            </div>
          </div>
        </div>
      </div>
      <div id="id14" class="bg2  pt-29 pb-47">
        <div class="container">
          <div class="title-box">
            <div class="title">发展历程</div>
            <div class="subtitle">DEVELOPMENT HISTORY</div>
          </div>
          <div class="setup-box row mt-37px">
            <div class="setup-liney-box">
              <div class="setup-liney"></div>
              <div class="date-content">
                
                <div class="date-line col-xs-12">
                </div>
                <div class="date-line col-xs-12">
                  <div class="year year-even">2024</div>
                  <div class="text">惠宾科技不断向前，携手更多合作伙伴开拓医疗信息化新征程……</div>
                </div>
                <div class="date-line text-right col-xs-12">
                  <div class="year year-odd">2023</div>
                  <div class="text">
                    惠宾科技携手西北大学第一医院，共同缔造了医疗信息化的新篇章
                    <br>
                    由惠宾科技精心搭建的互联网医院，顺利通过了严格的互联网医院资质评审
                    <br>
                    成功取得互联网医院牌照
                  </div>
                </div>
                <div class="date-line col-xs-12">
                </div>
                <div class="date-line col-xs-12">
                </div>
                <div class="date-line col-xs-12">
                  <div class="year year-even">2021</div>
                  <div class="text">研发推出日间手术管理系统，结合医院的实际临床业务的特点，进行整体业务流程的重组，实现日间手术流程标准化、明确化，最终达到医院对日间手术患者进行统一管理。</div>
                </div>
                
                <div class="date-line col-xs-12 text-right">
                  <div class="year year-odd">2019</div>
                  <div class="text">
                    研发推出互联网医院产品，实现线上问诊、处方流转、药品配送等业务
                    <br>
                    并为多家医院和区域实现互联网医疗运营服务
                  </div>
                </div>
                <div class="date-line col-xs-12">
                </div>
                <div class="date-line col-xs-12">
                  
                </div>
                
                <div class="date-line col-xs-12">
                  <div class="year year-even">2018</div>
                  <div class="text">
                    承建西安市民健康服务平台，成为区域专业互联网医疗运营机构
                    <br>
同年推出惠医直播，成为陕西专业的医疗专家直播平台
                  </div>
                </div>
                
                <div class="date-line col-xs-12 text-right">
                  <div class="year year-odd">
                    2016
                  </div>
                  <div class="text">
                    上线惠宾健康服务平台，组建专业的互联网医疗运营团队 构建“线上线下一体化”患者服务中心
                  </div>
                </div>
                
                <div class="date-line col-xs-12">
                  
                </div>
                
                <div class="date-line col-xs-12">
                  
                </div>
                
                <div class="date-line col-xs-12">
                  <div class="year year-even">
                    2013
                  </div>
                  <div class="text">
                    推出智能导分诊系统、预住院管理系统、掌上医院等系列产品并
                    <br>
在多家医院上线运行。
                  </div>
                </div>
                <div class="date-line col-xs-12 text-right">
                  <div class="year year-odd">
                    2010
                  </div>
                  <div class="text">
                    成功签约西京医院门诊一卡通建设项目，通过该项目与中国建设银行
                    <br>
共同打造银医合作之执行点扣费的“西京模式”
                  </div>
                </div>
                <div class="date-line col-xs-12">
                  
                </div>
                <div class="date-line col-xs-12">
                  
                </div>
                <div class="date-line col-xs-12">
                  <div class="year year-even">
                    2009
                  </div>
                  <div class="text">
                    惠宾科技注册成立，研发推出门诊一卡通系统、预约挂号系统、
                    <br>
门诊医疗管理与服务系统等软件产品
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      
      <div class="bg1 about-number-box flex-item-center">
        <div class="container">
          <div class="col-lg-3 col-md-4 col-xs-6 text-center" v-for="(item,index) in mumberList" :key="index">
            <div class="total-box">
              <span class="number wow animate__animated animate__fadeInDown" data-wow-delay="10ms" data-wow-duration="3s">{{item.num}}</span>
              <span class="unit">{{ item.unit }}</span>
            </div>
            <div class="desc">
              {{ item.desc }}
            </div>
          </div>
        </div>
      </div>
      <div id="id15" class="bg2 w100 pt-33 pb-40">
        <div class="container">
          <div class="title-box">
            <div class="title">资质荣誉</div>
            <div class="subtitle">DEVELOPMENT HISTORY</div>
          </div>
          <div class="zizhi-box row">
            <!-- <div class="zizhi-item col-lg-4 col-xs-12" v-for="(item,index) in zizhiList" :key="index">
              <img :src="item.img" alt="" srcset="">
              <div class="zizhi-item-desc mt-9 text-center">{{ item.desc }}</div>
            </div> -->
            
            <div class="swiper">
              <swiper ref="mySwiper" :options="swiperOptions1">
                <swiper-slide v-for="(item,index) in zizhiList" :key="index">
                  <img :src="item.img" class="center-block">
                </swiper-slide>
              </swiper>
              <div class="swiper-pagination" slot="pagination"></div>
              <!-- 如果需要导航按钮 -->
              <!-- <div class="swiper-button-prev swiper-button-white"></div>
              <div class="swiper-button-next swiper-button-white"></div> -->
            </div>
          </div>  
        </div>
      </div>
      <div id="id16" class="bg1 w100 pt-33 pb-40">
        <div class="container">
          <div class="title-box">
            <div class="title">联系我们</div>
            <div class="subtitle">DEVELOPMENT HISTORY</div>
          </div>
          <div class="lianxi-box row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="">
                <div class="percentage100 map-title">公司地址</div>
                <img class="percentage100" src="@/assets/img/map.jpg" alt="公司地址" srcset="">
              </div>
            </div>
            <div class="lianxi-content col-lg-6 col-sm-12 col-xs-12">
                <div class="map-title">联系方式</div>
                <div class="company-name">陕西惠宾电子科技有限公司</div>
                <div class="lianxi-item-box">
                  <div class="lianxi-item">
                    <img class="lianxi-icon" src="../assets/img/lianxi-tel.png" alt="" srcset="">
                    <div class="lianxi-fangshi">
                      <div class="label-title">联系电话</div>
                      <div class="label-num">029-89531063</div>
                    </div>
                  </div>
                  <div class="lianxi-item">
                    <img class="lianxi-icon" src="@/assets/img/lianxi-tel.png" alt="" srcset="">
                    <div class="lianxi-fangshi">
                      <div class="label-title">服务热线</div>
                      <div class="label-num">400-0553-888</div>
                    </div>
                  </div>
                  <div class="lianxi-item">
                    <img class="lianxi-icon" src="@/assets/img/lianxi-tel.png" alt="" srcset="">
                    <div class="lianxi-fangshi">
                      <div class="label-title">电子邮箱</div>
                      <div class="label-num">hbkj@hbdzoms.com</div>
                    </div>
                  </div>
                  <div class="lianxi-item">
                    <img class="lianxi-icon" src="@/assets/img/lianxi-tel.png" alt="" srcset="">
                    <div class="lianxi-fangshi">
                      <div class="label-title">公司地址</div>
                      <div class="label-num">西安市碑林区咸宁西路29号咸宁国际广场5单元26楼</div>
                    </div>
                  </div>
                </div>
            </div>
          </div>  
        </div>
      </div>
    </div>
    <!-- <shiyong></shiyong> -->
    <bottom-footer @active="getActive"></bottom-footer>
  </div>
</template>

<script>
import bottomFooter from '@/components/bottomFooter.vue'
import shiyong from '@/components/shiyong.vue'
import AnimatedNumber from "animated-number-vue";
import { WOW } from "wowjs";
export default {
  name: 'about',
  components: {
    bottomFooter,
    shiyong,
    AnimatedNumber
  },
  data() {
    return {
      isAboutNumber:false,
      scrollTimer:null,
      id:-1,
      elTop:0,
      initWow:null,
      swiperOption: {
          loop: false,
          autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false
          },
          // pagination: {
          //     el: '.swiper-pagination',
          //     type: 'fraction',
          //     clickable: true
          // },
      },
      swiperOptions1: {
        slidesPerView: 1,
          loop: false,
          autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false
          },
          // pagination: {
          //     el: '.swiper-pagination',
          //     type: 'fraction',
          //     clickable: true
          // },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
      },   
      mumberList:[
        {
         num:15,
         unit:"年",
         desc:"行业经验"
        },
        {
         num:69,
         unit:"%",
         desc:"西安市场占有率"
        },
        {
         num:36,
         unit:"家",
         desc:"三级医院"
        },
        {
         num:50,
         unit:"＋",
         desc:"软件著作权"
        }
        
      ],
      zizhiList:[
        {
          img:require("@/assets/img/zizhi7.jpg"),
          desc:""
        }
      ]
    }
  },
  created () {
    this.getElTop();
  },
  mounted() {
    this.wowInit();

    window.addEventListener('scroll', this.handleWheel);
    
  },
  destroyed (){
    window.removeEventListener('scroll',null);
  },
  methods: {
    wowInit(){
      this.$nextTick(() => {
        let wow=new WOW({
          boxClass: 'wow', // default
          animateClass: 'animated', // default
          offset: 50, // default
          mobile: true, // default
          live: false,
        
          // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.
        
          callback: function (box) {
            console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
          }
        });
        wow.init();
      });
    },
    formatToPrice(value) {
      return `${value.toFixed(0)}`;
    },
    getActive(e){
      this.id=e.id;
      this.getElTop();
    },
    getElTop(){
      this.elTop=0;
      let id=this.$route.query.id;
      
      if(this.id>0){
        id=this.id;
      }
      let el=null;
      let time=setTimeout(()=>{
        this.$nextTick(()=>{
          el=$("#id"+id);
          console.log("about:",el);
          
          if(el.offset()){
            this.elTop=el.offset().top;
            
            this.aboutNumberTop=$(".about-number-box").offset().top;
            $("html,body").animate({scrollTop: this.elTop}, 800);
          }
          clearTimeout(time);
          time=null;
        });   
      },1000); 
    },
    handleWheel(event){
      clearTimeout(this.scrollTimer);
      this.scrollTimer=setTimeout(()=>{
        this.$nextTick(()=>{
          this.scrollTop=window.pageYOffset || document.documentElement.scrollTop;
          let viewHeight=  window.innerHeight || document.documentElement.clientHeight;
          let elHeight=$(".about-number-box").height();
          let showViewHeight=(this.scrollTop+viewHeight)-elHeight / 2;
          let numel=$(".about-number-box")[0];
          if(numel){
            if(showViewHeight>$(".about-number-box").offset().top){
              this.isAboutNumber=true;
              // $(".total-box .number").addClass('animated fadeIn');

            }else{
              this.isAboutNumber=false;
              // $(".total-box .number").removeClass('animated fadeIn');
            }
          }
          
          this.scrollTimer=null;
        });
      },50);
      
		},
  },
}
</script>

<style scoped lang="scss">
@mixin content-text-font{
	font-size: 1.6rem;
	color: #333333;
	font-weight: 400;
	font-family: Microsoft YaHei, Microsoft YaHei;
	font-weight: 400;
	line-height: 2.4rem;
}
.swiper{
    position: relative;
    .swiper-button-prev{
      width: 48px;
      height: 48px;
      left: -20px;
      background-color: rgba(153,153,153, 0.6);
      background-size:60% 60%;
      border-radius: 50%;
    }
    .swiper-button-next{
      width: 48px;
      height: 48px;
      right: -20px;
      background-color: rgba(153,153,153, 0.6);
      background-size:60% 60%;
      border-radius: 50%;
    }
  }
.title-box{
  text-align: center;
  .title{
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 3.6rem;
    color: #333333;
  }
  .subtitle{
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 1.4rem;
    color: #999999;
  }
}

.content-box{
  margin-top: 9.5rem;
}
.content-text{
  display: flex;
  align-items: center;
  @include content-text-font;
}
.setup-liney-box{
  position: relative;
  .setup-liney{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 1005px;
    background: linear-gradient( 180deg, rgba(0,40,128,0) 0%, #002880 62%, #002880 100%);
  }
  .date-content{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding-top: 7.6rem;
    .date-line{
      height: 10rem;
      width: 50%;
      .year{
        position: relative;
        font-family: DIN, DIN;
        font-weight: bold;
        font-size: 26px;
        color: #333333;
      }
      .year-even:after{
        position: absolute;
        top: 16px;
        left: -20px;
        content: " ";
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background: linear-gradient( 180deg, #6D93E7 0%, #144ECC 100%);
        z-index: 3;
      }
      
      .year-even:before{
        position: absolute;
        top: 13px;
        left: -20px;
        content: " ";
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: #ffffff;
        z-index: 1;
      }
      
      .year-odd:after{
        position: absolute;
        top: 16px;
        right: -19px;
        content: " ";
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background: linear-gradient( 180deg, #6D93E7 0%, #144ECC 100%);
        z-index: 3;
      }
      .year-odd:before{
        position: absolute;
        top: 13px;
        right: -19px;
        content: " ";
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: #ffffff;
        z-index: 1;
      }
      .text{
        @include content-text-font;
      }
    }
  }
}
.about-number-box{
  width: 100%;
  height: 28.2rem;
  background-image: url("../assets/img/about-bg1.jpg");
  background-size: 100% 100%;
  .total-box{
    .number{
      font-family: DIN, DIN;
      font-weight: 400;
      font-size: 4.8rem;
      color: #FFFFFF;
    }
    .unit{
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 1.4rem;
      color: #FFFFFF;
    }
  }
  
  .desc{
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 1.6rem;
    color: #FFFFFF;
  }
}
.zizhi-box{
  margin-top: 10rem;
  .zizhi-item{
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 10rem;
  }
}
.map-title{
  display: block;
  // width: 100%;
  padding-bottom: 4rem;
  text-align: left;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  font-size: 2.8rem;
  color: #081944;
}
.company-name{
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 700;
  font-size: 2rem;
  color: #333333;
}
.tips{
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 1.6rem;
  color: #333333;
}
.lianxi-item-box{
  .lianxi-item{
    display: flex;
    align-items: center;
    padding-top: 4rem;
    .lianxi-icon{
      width: 3.8rem;
      height: 3.8rem;
    }
   .lianxi-fangshi{
    padding-left: 1rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 700;
    font-size: 1.6rem;
    color: #333333;
   }
  }
}
.lianxi-box{
  margin: auto;
  margin-top: 10rem;
  padding-left: 7%;
}
.lianxi-content{
  padding-left: 16.7rem;
}
</style>